import { React, useState } from "react";
import Select from "react-select";
import { imageURl } from "../../libs/env";
import ShowAudioModal from "../modals/ShowAudioModal";
export function ListeningSetting({
  handleSelectedValue,
  formData,
  Dropdownitems,
  IsGenerating,
  p_class
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedAudio, setSelectedAudio] = useState(null);
  const [AudioModel, setAudioModel] = useState(false);
  const audioToggle = () => setAudioModel(!AudioModel);
  const handlePlayAudio = (audioData) => {
    if(audioData?.audio_url)
    {
        setSelectedAudio(audioData);
        audioToggle();
    }
  };
  let select_disabled = "";
  if (IsGenerating) {
    select_disabled = "react-select-disabled";
  }
  const selectedVoice1 = Dropdownitems?.voice_samples?.find(
    (item) => item.short_name === formData?.voice_id?.speaker_1
  );
  const selectedVoice2 = Dropdownitems?.voice_samples?.find(
    (item) => item.short_name === formData?.voice_id?.speaker_2
  );
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      padding: 8,
    }),
    icon: {
      width: 18,
      height: 18,
      marginRight: 8,
      cursor: "pointer", // Add cursor pointer to indicate the icon is clickable
    },
  };
  return (
    <>
    <div className={`col-12 ${p_class} pt-2 pb-1`}>
      <label class="pb-2 fw-600" for="grammar_type">
        Select accent (optional)
      </label>
      <div className="col-12 d-flex">
        <div class="col-6 form-group md-group show-label pe-3">
          <Select
            className={`form-select form-select-bold rounded-5 pf-1 ${select_disabled}`}
            placeholder="Speaker 1"
            styles={customStyles}
            value={selectedVoice1?.name ? {label: selectedVoice1?.name} : null}
            isClearable
            onChange={handleSelectedValue}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
            options={Dropdownitems.voice_samples?.map((item) => {
              return {
                value: item.short_name,
                label: item.name,
                name: "speaker_1",
                icon: `${imageURl}/play_audio.png`,
                audio_url: item.audio_url,
              };
            })}
            formatOptionLabel={({ label, icon, audio_url }) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                {icon && (
                  <img
                    src={icon}
                    alt={label}
                    style={customStyles.icon}
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePlayAudio({"audio_url":audio_url, "label":label });
                    }}
                  />
                )}
                <span>
                  {label}
                </span>
              </div>
            )}
            isDisabled={IsGenerating}
            isRequired={true}
            menuIsOpen1={isMenuOpen}
            onMenuOpen1={() => {
              setIsMenuOpen(true);
              }}
            onMenuClose1={() => {
              AudioModel ?
              setIsMenuOpen(true):
              setIsMenuOpen(false);
              }}
          />
        </div>
        <div class="col-6 ps-1 form-group md-group show-label">
          <Select
            className={`form-select form-select-bold rounded-5 pf-1 ${select_disabled}`}
            placeholder="Speaker 2"
            styles={customStyles}
            value={selectedVoice2?.name ? {label: selectedVoice2?.name} : null}
            isClearable
            onChange={handleSelectedValue}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
            options={Dropdownitems.voice_samples?.map((item) => {
              return {
                value: item.short_name,
                label: item.name,
                name: "speaker_2",
                icon: `${imageURl}/play_audio.png`,
                audio_url: item.audio_url,
              };
            })}
            formatOptionLabel={({ label, icon, audio_url }) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                {icon && (
                  <img
                    src={icon}
                    alt={label}
                    style={customStyles.icon}
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePlayAudio({"audio_url":audio_url, "label":label });
                    }}
                  />
                )}
                <span>
                  {label}
                </span>
              </div>
            )}
            isDisabled={IsGenerating}
            isRequired={true}
            menuIsOpen2={isMenuOpen}
            onMenuOpen2={() => {
              setIsMenuOpen(true);
              }}
            onMenuClose2={() => {
              AudioModel ?
              setIsMenuOpen(true):
              setIsMenuOpen(false);
              }}
          />
        </div>
      </div>
    </div>
      <ShowAudioModal audioData={selectedAudio} isOpen={AudioModel} toggle={audioToggle}  />
    </>
  );
}
